import React, { useEffect, useMemo, useState } from "react";
import { addSupplier, getSuppliers, removeSupplier, updateSupplier } from "../storage";
import "../StockInward.css";

export default function SupplierMaster() {
  const [form, setForm] = useState({ name: "", contact: "", address: "" });
  const [suppliers, setSuppliers] = useState([]);
  const [query, setQuery] = useState("");
  const [editingSupplierId, setEditingSupplierId] = useState("");
  const [saving, setSaving] = useState(false);

  const refresh = async () => {
    try {
      const list = await getSuppliers();
      setSuppliers(list || []);
    } catch (err) {
      console.error(err);
      alert("Failed to load suppliers.");
    }
  };
  useEffect(() => { refresh(); }, []);

  const filtered = useMemo(() => {
    if (!query) return suppliers;
    const q = query.toLowerCase();
    return suppliers.filter(
      (s) => s.name.toLowerCase().includes(q) || (s.contact || "").toLowerCase().includes(q)
    );
  }, [suppliers, query]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const name = form.name.trim();
    if (!name) return;
    try {
      setSaving(true);
      const payload = { name, contact: form.contact.trim(), address: form.address.trim() };
      if (editingSupplierId) {
        await updateSupplier(editingSupplierId, payload);
      } else {
        await addSupplier(payload);
      }
      setForm({ name: "", contact: "", address: "" });
      setEditingSupplierId("");
      await refresh();
    } catch (err) {
      console.error(err);
      alert("Failed to save supplier.");
    } finally {
      setSaving(false);
    }
  };

  const startEdit = (supplier) => {
    if (!supplier?.id) return;
    setEditingSupplierId(supplier.id);
    setForm({
      name: String(supplier.name || ""),
      contact: String(supplier.contact || ""),
      address: String(supplier.address || ""),
    });
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (e) {
      // ignore
    }
  };

  const cancelEdit = () => {
    setEditingSupplierId("");
    setForm({ name: "", contact: "", address: "" });
  };

  return (
    <div className="stock-inward-container" style={{paddingTop: 0}}>
      <div className="form-card">
        <div className="card-header">
          <h2 className="card-title">Supplier Master</h2>
        </div>
        <form className="inward-form" onSubmit={onSubmit}>
          <div className="form-grid">
          <div className="field fl-field">
            <input
              id="sup-name"
              className="fl-input input-field"
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder=" "
              required
            />
            <label htmlFor="sup-name" className="fl-label">Supplier Name</label>
          </div>
          <div className="field fl-field">
            <input
              id="sup-contact"
              className="fl-input input-field"
              type="text"
              value={form.contact}
              onChange={(e) => setForm({ ...form, contact: e.target.value })}
              placeholder=" "
            />
            <label htmlFor="sup-contact" className="fl-label">Contact</label>
          </div>
          <div className="field full fl-field">
            <textarea
              id="sup-address"
              className="fl-input input-field"
              value={form.address}
              onChange={(e) => setForm({ ...form, address: e.target.value })}
              rows={2}
              placeholder=" "
            />
            <label htmlFor="sup-address" className="fl-label">Address</label>
          </div>
          </div>
          <div className="form-actions">
            {editingSupplierId ? (
              <>
                <button type="button" className="btn-secondary" onClick={cancelEdit} disabled={saving}>
                  Cancel Edit
                </button>
                <button type="submit" className="btn-primary" disabled={saving}>
                  {saving ? "Updating..." : "Update Supplier"}
                </button>
              </>
            ) : (
              <button type="submit" className="btn-primary" disabled={saving}>
                {saving ? "Saving..." : "Add Supplier"}
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="entries-card">
        <div className="card-header" style={{borderBottom: 'none'}}>
          <h2 className="card-title">Suppliers</h2>
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search suppliers..."
            className="input-field"
            style={{maxWidth: 280}}
          />
        </div>
        <div className="entries-table-container">
        <table className="entries-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Contact</th>
              <th>Address</th>
              <th style={{ width: 140 }} className="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={4} className="empty-state">
                  No suppliers yet
                </td>
              </tr>
            ) : (
              filtered.map((s) => (
                <tr key={s.id}>
                  <td>{s.name}</td>
                  <td>{s.contact}</td>
                  <td>{s.address}</td>
                  <td className="actions text-right">
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                      <button
                        type="button"
                        className="btn-secondary"
                        title="Edit"
                        onClick={() => startEdit(s)}
                        style={{ padding: "0.35rem 0.7rem", fontSize: "0.75rem" }}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="btn-remove"
                        title="Delete"
                        onClick={async () => {
                          if (window.confirm("Delete supplier?")) {
                            try {
                              await removeSupplier(s.id);
                              if (editingSupplierId === s.id) {
                                cancelEdit();
                              }
                              await refresh();
                            } catch (err) {
                              console.error(err);
                              alert("Failed to delete supplier.");
                            }
                          }
                        }}
                      >
                        x
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}

